import { FunctionComponent } from "react";
import style from "./DotsPattern.module.scss";

interface DotsPatternProps {
  top?: number;
  bottom?: number;
  right?: number;
  left?: number;
}

const DotsPattern: FunctionComponent<DotsPatternProps> = ({
  bottom,
  left,
  right = 350,
  top,
}) => {
  return (
    <div className={`relative`}>
      <div
        className={`hidden md:!block ${style.dotsContainer}`}
        style={{
          top: `${top}px`,
          bottom: `${bottom}px`,
          right: `${right}px`,
          left: `${left}px`,
        }}
      ></div>
    </div>
  );
};

export default DotsPattern;
